
import React from "react";
import { Schemes, Utils } from "../../utils";
import { i18nManager } from "../../i18n";
import { ITransaction } from "../../services";
import ErrorSuccessView from "../ErrorSuccessView";
import { Button, FormControl, NumberInput, Scheme } from "@rivtn/noseur";
import { PaymentMethod, PaymentMethodAttributes } from "../../constants/PaymentMethod";

export interface GiftCardProps {
    businessId: string;
    transaction: ITransaction;
    paymentSuccessful: () => void;
    loadingState: [boolean, React.Dispatch<React.SetStateAction<boolean>>];
    fetchTransaction: (onDone?: (result?: ITransaction, error?: any) => void) => void;
}

function GiftCard(props: GiftCardProps) {

    const transaction = props.transaction;
    const [_, setLoading] = props.loadingState;
    const labels = i18nManager.Labels.method.gift_card;
    const [giftCardNumber, setGiftCardNumber] = React.useState<string>();
    const [serviceErrors, setServiceErrors] = React.useState<string[]>([]);
    const [serviceSuccesses, setServiceSuccesses] = React.useState<string[]>([]);
    const [serviceWarnings, setServiceWarnings] = React.useState<string[]>([]);
    const giftCardPaymentMethodAttribute = PaymentMethodAttributes[PaymentMethod.GIFT_CARD];
    const countryAndCurrency = i18nManager.CountriesAndCurrencies.find(l => l.value === transaction.charge_country_code);

    if (serviceSuccesses.length) {
        return Utils.buildPaymentCompletedView(transaction, serviceSuccesses);
    }

    if (serviceWarnings.length) {
        return Utils.buildPartialPaymentView(transaction, serviceWarnings, () => {
            setServiceWarnings([]);
        }, () => {
            setServiceWarnings([]);
        });
    }

    if (serviceErrors.length) {
        return Utils.buildPaymentErrorView(transaction, serviceErrors, () => {
            setServiceErrors([]);
        });
    }

    return (<div className="gift-card credit-card">
        <span className="title">{labels.title.replace("${amount}", `${countryAndCurrency?.currency_sign} ${(transaction.amount/ Utils.AMOUNT_UNIT)}`)}</span>
        <div className="card-info" style={{ marginTop: 30 }}>
            <span className="title">{labels.gift_card_number}</span>
            <span className="desc">{labels.desc}</span>
            <FormControl fill scheme={Schemes.RIVTN_PLOUTOUS} rightContent={<giftCardPaymentMethodAttribute.icon fill="#008668" />}>
                <NumberInput name="gift_card_number" placeholder={labels.enter_gift_card_number}
                    onInput={(e: any) => setGiftCardNumber(e.target.value)} />
            </FormControl>
        </div>
        <Button raised fill scheme={Schemes.RIVTN_PLOUTOUS} className="pay" text={i18nManager.Labels.common.pay_now}
            disabled={!giftCardNumber} onClick={confirmPayment} />
    </div>);

    async function confirmPayment() {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            if (giftCardNumber?.includes("11111")) {
                setServiceErrors(["Sorry to hear that your payment was unsuccessful. Don't worry, it's frustrating, but you can try again or explore other options."]);
                return;
            }
            setServiceSuccesses(["Thank You. We Are Delighted To Inform You That Your Payment Was Successful."]);
            props.paymentSuccessful();
        }, 3000);
    }

}

export default GiftCard;
